<template>
  <div class="modal-wrapper">
    <div class="modal">
      <slot name="title"></slot>
      <slot name="content"></slot>
      <footer>
        <slot name="footer-content"></slot>
        <router-link
          tag="button"
          v-if="btntext"
          :to="{ name: backlink }"
          type="button"
          class="primary"
        >
          {{ btntext }}
          <long-arrow width="16" height="18"></long-arrow>
        </router-link>
      </footer>
      <router-link
        v-if="backlink && backLinkText"
        :to="{ name: backlink }"
        class="back-link"
      >
        <long-arrow width="16" height="18" direction="left"></long-arrow>
        {{ backLinkText }}
      </router-link>
    </div>
  </div>
</template>

<script>
import LongArrow from "@/components/icons/LongArrowIcon";

export default {
  name: "AuthModal",
  components: {
    LongArrow
  },
  props: {
    btntext: {
      type: String
    },
    backlink: {
      type: String
    },
    backLinkText: {
      type: String
    }
  }
};
</script>

<style scoped lang="scss">
@import "../assets/styles/variables";

.modal-wrapper {
  z-index: 4;
  .modal {
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    position: relative;
    width: 50%;
    max-width: 700px;
    border: 1px solid $middle-gray;
    border-radius: 8px;
    padding: 75px;
    background: white;
    h1 {
      margin-bottom: 35px;
    }
    footer {
      margin: 30px 0 10px 0;
      display: flex;
      justify-content: flex-end;
    }
    .back-link {
      display: flex;
      position: absolute;
      bottom: 0;
      transform: translateY(50px) translateX(-50%);
      left: 50%;
      text-decoration: none;
      svg {
        margin-right: 10px;
      }
    }
  }
}
</style>
